export enum CampaignState {
    DRAFTED = 'DRAFTED',
    START_QUEUED = 'START_QUEUED',
    STARTED = 'STARTED',
    START_FAILED = 'START_FAILED',
    STOP_QUEUED = 'STOP_QUEUED',
    STOPPED = 'STOPPED',
    STOP_FAILED = 'STOP_FAILED'
}

export interface Campaign {
    id: string;
    tenantId: string;
    state: CampaignState;
    title: string;
    description?: string;
    createdAt: Date;
    updatedAt: Date;
}
